import React, { useCallback } from 'react'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { HistoryOutlined } from '@ant-design/icons'

import { showAuditModal } from 'app-redux/finance/actions'
import styles from './styles.module.scss'

const LastSentInfo = ({ dateTime, messageId, transTypeId, tranId }) => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()

  const handleClick = useCallback(() => {
    dispatch(showAuditModal({ trans_type_id: transTypeId, tran_id: tranId }))
  }, [dispatch, transTypeId, tranId])

  if (!dateTime) {
    return null
  }

  return (
    <span
      className={styles.lastSent}
      role="button"
      tabIndex={0}
      onClick={handleClick}
      onKeyDown={handleClick}
    >
      <HistoryOutlined />
      {formatMessage({ id: messageId }, { date: dayjs(dateTime).format('DD MMM YYYY HH:mm') })}
    </span>
  )
}

export default LastSentInfo
